function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as DetailUtils from '@shared/utils/detailUtils';
import { Stack, mergeStyleSets, ScreenWidthMinXLarge } from '@fluentui/react';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import classNames from 'classnames';
import { OdataRawObjectAppType, TermsStrings } from '@shared/Models';
import { routes, urlPush, urlReplace } from '@shared/routerHistory';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import Animation from '@shared/components/animation';
import SpzaComponent from '@shared/components/spzaComponent';
import { BreadcrumbUrl } from '@shared/components/breadcrumbUrl';
import { getGalleryRoute, isBagTransactable } from '@shared/utils/appUtils';
import Wizard from '@appsource/containers/wizard';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import { logger } from '@src/logger';
import { getUserType } from '@appsource/utils/checkoutSettings';
import { buildUrlToAppDetails, checkoutBillingCountry, getConsentState, isContactInfoHiddenInDisclaimer, redirectToAppDetails } from '@shared/utils/checkoutUtils';
import { DisclaimerComponent } from './disclaimerComponent';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { UserType } from '@microsoft-commerce/purchase-blends-component-library';
const pbTelemetry = Constants.Telemetry.PurchaseBlendsTelemetry;
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ pageAction }] = useTelemetry();
export class Checkout extends SpzaComponent {
    getChildContext() {
        return this.props.context;
    }
    fetchAppPricing(app) {
        const { checkout: { customers, activeCustomer }, billingCountryCode } = this.props;
        const billingCountry = checkoutBillingCountry({
            customers,
            activeCustomer,
            defaultBillingCountry: billingCountryCode
        });
        this.props.fetchPricing(app.entityId, app.appType === OdataRawObjectAppType.private, billingCountry);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        var _nextProps_app_pricingInformation_skus, _nextProps_app_pricingInformation, _nextProps_checkout_activeCustomer_address_country, _nextProps_checkout_activeCustomer_address, _nextProps_checkout_activeCustomer, _nextProps_app_pricingInformation_skus1, _nextProps_app_pricingInformation1, _nextProps_checkout_items_, _nextProps_checkout_items;
        const { initiatedCart } = this.state;
        if (!nextProps.app) {
            return;
        }
        if (((_nextProps_app_pricingInformation = nextProps.app.pricingInformation) === null || _nextProps_app_pricingInformation === void 0 ? void 0 : (_nextProps_app_pricingInformation_skus = _nextProps_app_pricingInformation.skus) === null || _nextProps_app_pricingInformation_skus === void 0 ? void 0 : _nextProps_app_pricingInformation_skus.length) === 0 && ((_nextProps_checkout_activeCustomer = nextProps.checkout.activeCustomer) === null || _nextProps_checkout_activeCustomer === void 0 ? void 0 : (_nextProps_checkout_activeCustomer_address = _nextProps_checkout_activeCustomer.address) === null || _nextProps_checkout_activeCustomer_address === void 0 ? void 0 : (_nextProps_checkout_activeCustomer_address_country = _nextProps_checkout_activeCustomer_address.country) === null || _nextProps_checkout_activeCustomer_address_country === void 0 ? void 0 : _nextProps_checkout_activeCustomer_address_country.toLowerCase()) === nextProps.app.pricingInformation.billingRegion.toLowerCase()) {
            redirectToAppDetails(Constants.Tabs.PlansAndPrice, this.props.app, this.props.context.buildHref);
        }
        // Initialize cart once if it wasn't
        if (!initiatedCart && ((_nextProps_app_pricingInformation1 = nextProps.app.pricingInformation) === null || _nextProps_app_pricingInformation1 === void 0 ? void 0 : (_nextProps_app_pricingInformation_skus1 = _nextProps_app_pricingInformation1.skus) === null || _nextProps_app_pricingInformation_skus1 === void 0 ? void 0 : _nextProps_app_pricingInformation_skus1.length) > 0 && !((_nextProps_checkout_items = nextProps.checkout.items) === null || _nextProps_checkout_items === void 0 ? void 0 : (_nextProps_checkout_items_ = _nextProps_checkout_items[0]) === null || _nextProps_checkout_items_ === void 0 ? void 0 : _nextProps_checkout_items_.product)) {
            var _nextProps_app_pricingInformation2;
            const sortedSkus = (((_nextProps_app_pricingInformation2 = nextProps.app.pricingInformation) === null || _nextProps_app_pricingInformation2 === void 0 ? void 0 : _nextProps_app_pricingInformation2.skus) || []).slice().sort((a, b)=>{
                return a.title > b.title ? -1 : a.title < b.title ? 1 : 0;
            });
            this.initializeCart(sortedSkus[0]);
            this.setState({
                initiatedCart: true
            });
        }
    }
    componentWillUnmount() {
        this.props.setIsDisabledBilling(false);
    }
    componentDidMount() {
        var _this_props_app_linkedAddIns, _this_props_userInfo, _this_props_userInfo1, _this_props_checkout_items, _this_props_checkout_activeCustomer_address, _this_props_checkout_activeCustomer, _this_props_app_pricingInformation_skus, _this_props_app_pricingInformation, _this_props_app, _this_props, _this_props_checkout_items1, _this_props_app_pricingInformation_skus1, _this_props_app_pricingInformation1, _this_props_app1;
        this.props.setIsDisabledBilling(true);
        // log telemetry for this page
        const isNewCustomer = this.isNewCustomer();
        const payloadDetails = {
            currentView: this.props.currentView,
            isNewCustomer
        };
        if (this.props.app && ((_this_props_app_linkedAddIns = this.props.app.linkedAddIns) === null || _this_props_app_linkedAddIns === void 0 ? void 0 : _this_props_app_linkedAddIns.length) > 0) {
            payloadDetails[Constants.Checkout.IsSaasBundle] = true;
            payloadDetails[Constants.Checkout.ContentId] = this.props.app.entityId;
            pageAction(null, {
                content: {
                    contentType: Constants.Telemetry.ContentType.CheckoutBundlePageView
                }
            });
        }
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            details: JSON.stringify(payloadDetails)
        };
        this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        // MSA users are not supported for checkout, redirect to home page
        if (((_this_props_userInfo = this.props.userInfo) === null || _this_props_userInfo === void 0 ? void 0 : _this_props_userInfo.signedIn) && ((_this_props_userInfo1 = this.props.userInfo) === null || _this_props_userInfo1 === void 0 ? void 0 : _this_props_userInfo1.isMSAUser)) {
            const marketplaceUrl = this.props.context.buildHref(routes.marketplace, null, {});
            urlReplace(marketplaceUrl);
        }
        this.handleUserNotLoggedIn();
        if (!this.props.checkout.customers) {
            // This should have been fetched already, but if it failed for some reason, fetch again on checkout page
            this.props.getCustomers();
        }
        if (((_this_props_checkout_items = this.props.checkout.items) === null || _this_props_checkout_items === void 0 ? void 0 : _this_props_checkout_items.length) > 0 && this.props.checkout.items[0].entityId !== this.props.app.entityId) {
            // if user is checking out another app, then clear the state so a new purchase can be initiated
            this.props.clearCheckoutState();
        }
        if (this.props.app && !this.props.app.pricingInformation) {
            this.fetchAppPricing(this.props.app);
        }
        const userCountry = (_this_props_checkout_activeCustomer = this.props.checkout.activeCustomer) === null || _this_props_checkout_activeCustomer === void 0 ? void 0 : (_this_props_checkout_activeCustomer_address = _this_props_checkout_activeCustomer.address) === null || _this_props_checkout_activeCustomer_address === void 0 ? void 0 : _this_props_checkout_activeCustomer_address.country;
        if (userCountry && (userCountry === null || userCountry === void 0 ? void 0 : userCountry.toLowerCase()) !== this.props.billingCountryCode.toLowerCase()) {
            // customer country is different from the billingCountryCode, which is not supported
            // for this case, we switch to the market of the customer (i.e. mcapi) footprint
            this.props.setBillingCountry(this.props.checkout.activeCustomer.address.country.toLowerCase());
            this.fetchAppPricing(this.props.app);
        }
        if (((_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_app = _this_props.app) === null || _this_props_app === void 0 ? void 0 : (_this_props_app_pricingInformation = _this_props_app.pricingInformation) === null || _this_props_app_pricingInformation === void 0 ? void 0 : (_this_props_app_pricingInformation_skus = _this_props_app_pricingInformation.skus) === null || _this_props_app_pricingInformation_skus === void 0 ? void 0 : _this_props_app_pricingInformation_skus.length) > 0 && ((_this_props_checkout_items1 = this.props.checkout.items) === null || _this_props_checkout_items1 === void 0 ? void 0 : _this_props_checkout_items1.length) === 0) {
            var _this_props_app_pricingInformation2, _this_props_app2;
            const sortedSkus = (((_this_props_app2 = this.props.app) === null || _this_props_app2 === void 0 ? void 0 : (_this_props_app_pricingInformation2 = _this_props_app2.pricingInformation) === null || _this_props_app_pricingInformation2 === void 0 ? void 0 : _this_props_app_pricingInformation2.skus) || []).slice().sort((a, b)=>{
                return a.title > b.title ? -1 : a.title < b.title ? 1 : 0;
            });
            this.initializeCart(sortedSkus[0]);
        }
        if (((_this_props_app1 = this.props.app) === null || _this_props_app1 === void 0 ? void 0 : (_this_props_app_pricingInformation1 = _this_props_app1.pricingInformation) === null || _this_props_app_pricingInformation1 === void 0 ? void 0 : (_this_props_app_pricingInformation_skus1 = _this_props_app_pricingInformation1.skus) === null || _this_props_app_pricingInformation_skus1 === void 0 ? void 0 : _this_props_app_pricingInformation_skus1.length) === 0) {
            // log telemetry for redirection
            const payload = {
                page: getWindow().location.href,
                action: Constants.Telemetry.Action.Redirecting,
                actionModifier: Constants.Telemetry.ActionModifier.OfferUnavailableInRegion,
                details: JSON.stringify({
                    isNewCustomer
                })
            };
            this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
            redirectToAppDetails(Constants.Tabs.PlansAndPrice, this.props.app, this.props.context.buildHref);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        var _this_props_userInfo, _this_props_userInfo1, _this_props_checkout_activeCustomer_address, _this_props_checkout_activeCustomer, _this_props_checkout, _this_props_billingCountryCode, _this_props_app_pricingInformation, _this_props_app, _prevProps_app_pricingInformation, _prevProps_app, _this_props_app_pricingInformation_skus, _this_props_app_pricingInformation1, _this_props_app1, _this_props;
        if (((_this_props_userInfo = this.props.userInfo) === null || _this_props_userInfo === void 0 ? void 0 : _this_props_userInfo.signedIn) && ((_this_props_userInfo1 = this.props.userInfo) === null || _this_props_userInfo1 === void 0 ? void 0 : _this_props_userInfo1.isMSAUser)) {
            const marketplaceUrl = this.props.context.buildHref(routes.marketplace, null, {});
            urlReplace(marketplaceUrl);
        }
        if (!prevProps.checkout.activeCustomer && ((_this_props_checkout = this.props.checkout) === null || _this_props_checkout === void 0 ? void 0 : (_this_props_checkout_activeCustomer = _this_props_checkout.activeCustomer) === null || _this_props_checkout_activeCustomer === void 0 ? void 0 : (_this_props_checkout_activeCustomer_address = _this_props_checkout_activeCustomer.address) === null || _this_props_checkout_activeCustomer_address === void 0 ? void 0 : _this_props_checkout_activeCustomer_address.country) && this.props.checkout.activeCustomer.address.country.toLowerCase() !== ((_this_props_billingCountryCode = this.props.billingCountryCode) === null || _this_props_billingCountryCode === void 0 ? void 0 : _this_props_billingCountryCode.toLowerCase())) {
            // customer has updated the billingCountryCode. If customer country is different from the billingCountryCode (unsupported scenario)
            // then, switch billingCountryCode back to the customer market
            this.props.setBillingCountry(this.props.checkout.activeCustomer.address.country.toLowerCase());
        }
        if (((_this_props_app = this.props.app) === null || _this_props_app === void 0 ? void 0 : (_this_props_app_pricingInformation = _this_props_app.pricingInformation) === null || _this_props_app_pricingInformation === void 0 ? void 0 : _this_props_app_pricingInformation.billingRegion) !== ((_prevProps_app = prevProps.app) === null || _prevProps_app === void 0 ? void 0 : (_prevProps_app_pricingInformation = _prevProps_app.pricingInformation) === null || _prevProps_app_pricingInformation === void 0 ? void 0 : _prevProps_app_pricingInformation.billingRegion) && ((_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_app1 = _this_props.app) === null || _this_props_app1 === void 0 ? void 0 : (_this_props_app_pricingInformation1 = _this_props_app1.pricingInformation) === null || _this_props_app_pricingInformation1 === void 0 ? void 0 : (_this_props_app_pricingInformation_skus = _this_props_app_pricingInformation1.skus) === null || _this_props_app_pricingInformation_skus === void 0 ? void 0 : _this_props_app_pricingInformation_skus.length)) {
            var _this_props_app_pricingInformation2, _this_props_app2;
            const sortedSkus = (((_this_props_app2 = this.props.app) === null || _this_props_app2 === void 0 ? void 0 : (_this_props_app_pricingInformation2 = _this_props_app2.pricingInformation) === null || _this_props_app_pricingInformation2 === void 0 ? void 0 : _this_props_app_pricingInformation2.skus) || []).slice().sort((a, b)=>{
                return a.title > b.title ? -1 : a.title < b.title ? 1 : 0;
            });
            this.initializeCart(sortedSkus[0]);
        }
        if (this.props.userInfo.loading !== prevProps.userInfo.loading) {
            this.handleUserNotLoggedIn();
        }
    }
    isNewCustomer() {
        var _this_props_checkout_customers, _this_props_checkout;
        return !this.props.checkout.activeCustomer && ((_this_props_checkout = this.props.checkout) === null || _this_props_checkout === void 0 ? void 0 : (_this_props_checkout_customers = _this_props_checkout.customers) === null || _this_props_checkout_customers === void 0 ? void 0 : _this_props_checkout_customers.length) === 0;
    }
    breadcrumbUrl() {
        const { app, context } = this.props;
        const { title, appType } = app;
        const { href, locKey } = getGalleryRoute({
            appType
        });
        const pdpUrl = buildUrlToAppDetails(Constants.Tabs.Overview, app, context.buildHref);
        const linksList = [
            {
                locKey
            },
            {
                locKey: title,
                href: pdpUrl
            },
            {
                locKey: context.loc('Checkout_CheckoutText')
            }
        ];
        return /*#__PURE__*/ _jsx(BreadcrumbUrl, {
            linksList: linksList,
            href: this.props.context.buildHref(href, null, {})
        });
    }
    getDisclaimer() {
        var _app_detailInformation;
        const { app = {}, checkout: { currentStep, customers, activeCustomer }, featureFlags: { showConsent }, billingCountryCode } = this.props;
        const billingCountry = checkoutBillingCountry({
            customers,
            activeCustomer,
            defaultBillingCountry: billingCountryCode
        });
        return currentStep === 2 && /*#__PURE__*/ _jsx(DisclaimerComponent, {
            "data-bi-id": pbTelemetry.PurchaseBlendsDisclaimerComponent,
            "data-bi-name": pbTelemetry.PurchaseBlendsDisclaimerComponentName,
            consentOption: getConsentState(billingCountry),
            isCountryExcluded: isContactInfoHiddenInDisclaimer(getConsentState(billingCountry)),
            hideContactCheckbox: !(showConsent === 'true'),
            termsOfUseUrl: app.licenseTermsUrl || '',
            privacyPolicyUrl: (_app_detailInformation = app.detailInformation) === null || _app_detailInformation === void 0 ? void 0 : _app_detailInformation.PrivacyPolicyUrl
        });
    }
    renderImpl() {
        var _checkout_items;
        const { app, app: { entityId } = {}, checkout, userInfo, isProfessionalService } = this.props;
        const { signedIn, isMSAUser, roleDefinitions } = userInfo;
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        const adminUser = getUserType(roleDefinitions) === UserType.myOrg;
        const isBagOffer = isBagTransactable(app);
        if (!app || ((_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items.length) === 0 || !userInfo || signedIn && isMSAUser || !signedIn || !checkout.customers) {
            return /*#__PURE__*/ _jsx("div", {
                className: "checkout-container-root",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "loader billing-terms",
                    children: /*#__PURE__*/ _jsx(Animation, {})
                })
            });
        }
        const containerClass = classNames('checkout-container-root-horizontal', {
            'no-breadcrumbs': isProfessionalService
        });
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: containerClass,
                    children: [
                        /* not using the breadcrumbUrl 'hideBreadcrumbUrl' props because the breadcrumbUrl height stay as is */ !isProfessionalService && this.breadcrumbUrl(),
                        /*#__PURE__*/ _jsxs(Stack, {
                            horizontal: true,
                            horizontalAlign: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "checkout-content",
                                    children: /*#__PURE__*/ _jsx("h1", {
                                        className: "title-header",
                                        children: this.props.context.loc('Checkout_CheckoutText', 'Checkout')
                                    })
                                }),
                                !isOneTimePayment && !isProfessionalService && /*#__PURE__*/ _jsx(Stack.Item, {
                                    className: this.contentStyles.rightContainer,
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: this.contentStyles.termsContainer,
                                        children: this.getDisclaimer()
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Wizard, {
                    className: "mb-50",
                    app: app,
                    fetchedCustomers: !!checkout.customers,
                    adminFlow: adminUser,
                    isBagOffer: isBagOffer,
                    isProfessionalService: isProfessionalService
                }, "new-checkout")
            ]
        });
    }
    initializeCart(initialSku) {
        // If you has nothing in their cart, when they come to the checkout page,
        // default to the first sku as the selected sku
        if (initialSku && initialSku.termPrices && initialSku.termPrices.length > 0) {
            const currency = initialSku.currencyCode || Constants.usdCurrency;
            const defaultQuantity = initialSku.minQuantity ? initialSku.minQuantity.toString() : '1';
            this.updateCart(initialSku.id, initialSku.title, initialSku.description, initialSku.termPrices[0], currency, defaultQuantity, initialSku.isQuantifiable, initialSku.minQuantity, initialSku.maxQuantity);
        }
    }
    goToConfirmationPage() {
        const orderConfirmationUrl = this.props.context.buildHref(routes.orderConfirmation, null, {}, true);
        urlPush(orderConfirmationUrl, true);
    }
    updateCart(id, title, description, price, currency, quantity, isQuantifiable, minQuantity, maxQuantity) {
        const prevCartItem = this.props.checkout.items[0];
        const cartItem = {
            id,
            title,
            description,
            unitPrice: {
                currency: currency || prevCartItem && prevCartItem.unitPrice.currency,
                value: price.value,
                unit: [
                    TermsStrings.Term1YString.toString(),
                    TermsStrings.YearString.toString()
                ].includes(price.unit) ? TermsStrings.YearString : TermsStrings.MonthString,
                freeDurationDays: price.freeDurationDays
            },
            entityId: this.props.app.entityId,
            appTitle: this.props.app.title,
            appImageUri: this.props.app.iconURL,
            linkedAddIns: this.props.app.linkedAddIns
        };
        cartItem.isQuantifiable = typeof isQuantifiable !== 'undefined' ? isQuantifiable : prevCartItem && prevCartItem.isQuantifiable;
        let quantityAsInt = parseInt(quantity, 10);
        if (isNaN(quantityAsInt)) {
            quantityAsInt = prevCartItem.quantity;
        }
        cartItem.quantityString = quantity === undefined ? prevCartItem.quantityString : quantity;
        cartItem.quantity = quantityAsInt;
        cartItem.minQuantity = minQuantity || prevCartItem && prevCartItem.minQuantity;
        cartItem.maxQuantity = maxQuantity || prevCartItem && prevCartItem.maxQuantity;
        // every time something changes in the cart we reset status for calcluate now link,
        // this should only be done if we also have a payment instrument selected
        if (JSON.stringify(cartItem) !== JSON.stringify(prevCartItem)) {
            this.props.setCartItem(cartItem);
        }
    }
    logClickEvent(clickAction, details) {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: clickAction,
            appName: this.props.app.entityId,
            details: JSON.stringify(DetailUtils.addSaaSBundleProperties(details, this.props.app))
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
    }
    constructor(props){
        super(props, props.context), _define_property(this, "instrument", void 0), _define_property(this, "logOldCheckoutStarted", ()=>{
            var _checkout_items, _getWindow_location, _getWindow;
            const { checkout, userInfo: { roleDefinitions } = {}, app, isProfessionalService } = this.props;
            const isAdminUser = getUserType(roleDefinitions) === UserType.myOrg;
            const isBagOffer = isBagTransactable(app);
            const cartItem = (_checkout_items = checkout.items) === null || _checkout_items === void 0 ? void 0 : _checkout_items[0];
            const userType = getUserType(roleDefinitions);
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
                action: Constants.Telemetry.Action.OldCheckout,
                actionModifier: Constants.Telemetry.ActionModifier.Start,
                details: JSON.stringify({
                    entityId: (cartItem === null || cartItem === void 0 ? void 0 : cartItem.entityId) || '',
                    appTitle: (cartItem === null || cartItem === void 0 ? void 0 : cartItem.appTitle) || '',
                    userType,
                    adminFlow: isAdminUser,
                    isBagOffer,
                    isProfessionalService
                })
            };
            this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        }), _define_property(this, "onModalDismiss", ()=>{
            var _getWindow_location, _getWindow;
            const { checkoutId } = this.props;
            const action = Constants.Telemetry.Action.Checkout;
            const actionModifier = Constants.Telemetry.ActionModifier.CloseAuth;
            const payload = {
                page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
                action,
                actionModifier,
                details: JSON.stringify({
                    checkoutId
                })
            };
            SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.info(payload.details, {
                action,
                actionModifier
            });
            redirectToAppDetails(Constants.Tabs.PlansAndPrice, this.props.app, this.props.context.buildHref);
        }), _define_property(this, "handleUserNotLoggedIn", ()=>{
            const { userInfo, isProfessionalService, openModal } = this.props;
            const { openedSignModal } = this.state;
            if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.signedIn) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.loading) && !openedSignModal) {
                if (isProfessionalService) {
                    this.setState({
                        openedSignModal: true
                    });
                    openModal({
                        modalId: Constants.ModalType.SignIn,
                        disableDismissModal: true
                    });
                } else {
                    openModal({
                        modalId: Constants.ModalType.SignIn,
                        disableDismissModal: false,
                        onModalDismiss: this.onModalDismiss
                    });
                }
            }
        }), _define_property(this, "contentStyles", mergeStyleSets({
            azureSubscriptionPurchaseContainer: {
                boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
                maxWidth: '220px',
                wordBreak: 'keep-all',
                padding: '8px',
                zIndex: 2,
                [`@media (max-width: 1520px)`]: {
                    display: 'none'
                }
            },
            rightContainer: {
                position: 'absolute',
                top: '132px',
                right: '64px',
                [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
                    display: 'none'
                }
            },
            footerContainer: {
                bottom: '84px',
                right: '64px',
                top: 'unset'
            },
            termsContainer: {
                [`@media (max-width: 1720px)`]: {
                    display: 'none'
                }
            }
        }));
        this.instrument = SpzaInstrumentService.getProvider();
        this.state = {
            initiatedCart: false,
            openedSignModal: false
        };
    }
}
Checkout.childContextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    locDateString: PropTypes.func,
    locale: PropTypes.string,
    entityType: PropTypes.string,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    contactCallback: PropTypes.func,
    openTileCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    reportAbuseCallback: PropTypes.func,
    getAppHeaderHeight: PropTypes.func,
    getTileOnDemandLoadingService: PropTypes.func,
    query: PropTypes.object
};
